import { ProfileSettingType } from '@diritto/common/account/constants/profile-setting.constant';
import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { HeaderNavMenu, WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { WebViewTrackingEventParams } from '@diritto/common/app/webview-tracking-event.constant';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';

export interface WebViewEvent<I extends WebViewEventType> {
  type: I;
  message?: WebViewEventParams[I];
}

export enum WebViewEventType {
  OpenSign = 'OpenSign',
  ChangeProfile = 'ChangeProfile',
  OpenSignWebView = 'OpenSignWebView',
  CloseSignWebView = 'CloseSignWebView',
  CompleteSign = 'CompleteSign',
  RequestSign = 'RequestSign',

  OpenExternalWebView = 'OpenExternalWebView',
  CloseExternalWebView = 'CloseExternalWebView',

  SetPushOn = 'SetPushOn',
  GetPushOn = 'GetPushOn',

  PreventScreenshot = 'PreventScreenshot',
  RequestCameraPermission = 'RequestCameraPermission',

  Share = 'Share',
  FileDownload = 'FileDownload',
  CopyText = 'CopyText',

  RequestInAppReview = 'RequestInAppReview',
  RequestProfileSetting = 'RequestProfileSetting',

  TrackEvent = 'TrackEvent',
  TrackSetPeople = 'TrackSetPeople',

  ShowAppHeader = 'ShowAppHeader',
  ChangeStatusBar = 'ChangeStatusBar',
  HistoryBack = 'HistoryBack',
  NavigateBack = 'NavigateBack',
  ResetToHome = 'ResetToHome',

  ShowToast = 'ShowToast',
  ShowModal = 'ShowModal',
  SetVolumeIntercept = 'SetVolumeIntercept',
}

export interface WebViewEventParams {
  [WebViewEventType.OpenSign]: undefined;
  [WebViewEventType.ChangeProfile]: { profileId: number };
  [WebViewEventType.OpenSignWebView]: { url: string };
  [WebViewEventType.CloseSignWebView]: undefined;
  [WebViewEventType.CompleteSign]: { token?: { accessToken: string; refreshToken: string } };
  [WebViewEventType.RequestSign]: { ssoType: SsoType; isForLink: boolean };

  [WebViewEventType.OpenExternalWebView]: { url: string; title?: string };
  [WebViewEventType.CloseExternalWebView]: undefined;

  [WebViewEventType.SetPushOn]: { isPushOn: boolean };
  [WebViewEventType.GetPushOn]: undefined;

  [WebViewEventType.RequestCameraPermission]: undefined;
  [WebViewEventType.Share]: { text?: string; title: string; url: string };
  [WebViewEventType.FileDownload]: { url: string };
  [WebViewEventType.CopyText]: { text: string };
  [WebViewEventType.PreventScreenshot]: { enable: boolean };

  [WebViewEventType.RequestInAppReview]: undefined;
  [WebViewEventType.RequestProfileSetting]: { type: ProfileSettingType };

  [WebViewEventType.TrackEvent]: {
    event: TrackingEventType;
    params: WebViewTrackingEventParams[keyof WebViewTrackingEventParams];
  };
  [WebViewEventType.TrackSetPeople]: { properties: { [key: string]: any } };

  [WebViewEventType.ShowAppHeader]: {
    title?: string;
    leftMenuList?: HeaderNavMenu[];
    rightMenuList?: HeaderNavMenu[];
    screen: WebViewScreen;
    hideHeader?: boolean;

    contentId?: number;
    episodeId?: number;
    replyId?: number;
    hideContextMenu?: boolean;
  };
  [WebViewEventType.ChangeStatusBar]: {
    backgroundColor: string;
    barStyle: 'default' | 'light-content' | 'dark-content';
    animation?: 'none' | 'fade' | 'slide';
    hidden?: boolean | undefined;
    isModal?: boolean;
    isBottomSheet?: boolean;
  };
  [WebViewEventType.HistoryBack]: undefined;
  [WebViewEventType.NavigateBack]: undefined;
  [WebViewEventType.ResetToHome]: undefined;
  [WebViewEventType.ShowToast]: { text: string };
  [WebViewEventType.ShowModal]: {
    cancelText?: string;
    confirmText?: string;
    content?: string;
    title: string;
  };
  [WebViewEventType.SetVolumeIntercept]: { enabled: boolean };
}
